// This file is AUTOGENERATED, do not edit it manually!!!

export const filters = {
    Activity_Text: 'Activité',
    ActivityActualBilling: 'Activité facturable',
    ActivityActualCompletionDateCondition_Text: 'Date d\'achèvement réelle de l\'activité',
    ActivityActualCost: 'Coût réel de l\'activité',
    ActivityActualGreaterThanEstimated_Text: 'Activités sous-estimées',
    ActivityActualHours: 'Heures réelles de l\'activité',
    ActivityActualLaborBilling: 'Main-d\'œuvre facturable réelle de l\'activité ',
    ActivityActualLaborCost: 'Coût réel de la main-d\'œuvre de l\'activité',
    ActivityBillableHours: 'Heures facturables de l\'activité',
    ActivityBilled: 'Activité facturée',
    ActivityBilledLabor: 'Main-d\'œuvre facturée de l\'activité',
    ActivityBilledPercentage: 'Activité facturée, %',
    ActivityBudgetVariance: 'Écart budgétaire de l\'activité',
    ActivityCreationDateCondition_Text: 'Date de création de l\'activité',
    ActivityCreator_Text: 'Créateurs de l\'activité',
    ActivityCreatorCondition_Empty_Text: 'Système',
    ActivityCreatorCondition_Text: 'Créateur de l\'activité',
    ActivityCustomFieldCondition_Text: 'Champs personnalisés de l\'activité',
    ActivityDuration: 'Durée de l\'activité',
    ActivityEACBillableExpenses: 'Dépenses facturables EAC de l\'activité',
    ActivityEACBilling: 'Facturation EAC de l\'activité',
    ActivityEACCost: 'Coût EAC de l\'activité',
    ActivityEACExpenses: 'Dépenses EAC de l\'activité',
    ActivityEACLaborBilling: 'Main-d\'œuvre facturable EAC de l\'activité',
    ActivityEACLaborCost: 'Coût de la main-d\'œuvre EAC de l\'activité',
    ActivityEACNonBillableExpenses: 'Dépenses non facturables EAC de l\'activité',
    ActivityEndDateCondition_Text: 'Date de fin de l\'activité',
    ActivityEstimatedExpensesAmount: 'Dépenses ETC de l\'activité',
    ActivityEstimatedExpensesBillableAmount: 'Dépenses facturables ETC de l\'activité',
    ActivityEstimatedExpensesNonBillableAmount: 'Dépenses non facturables ETC de l\'activité',
    ActivityEstimatedHours: 'Heures estimées de l\'activité',
    ActivityETCBilling: 'Facturation ETC de l\'activité',
    ActivityETCCost: 'Coût ETC de l\'activité',
    ActivityETCLaborBilling: 'Main-d\'œuvre facturable ETC de l\'activité',
    ActivityETCLaborCost: 'Coût de la main-d\'œuvre ETC de l\'activité',
    ActivityExpectedProfit: 'Profit attendu de l\'activité',
    ActivityExpectedProfitPercentage: 'Profit attendu de l\'activité, %',
    ActivityExpensesAmount: 'Dépenses réelles de l\'activité',
    ActivityExpensesBillableAmount: 'Dépenses facturables réelles de l\'activité',
    ActivityExpensesBilledAmount: 'Dépenses facturées de l\'activité',
    ActivityExpensesNonBillableAmount: 'Dépenses non facturables réelles de l\'activité',
    ActivityHealthCondition_Text: 'Santé de l\'activité',
    ActivityHealthTypes: 'Santé de l\'activité',
    ActivityIsMilestone: 'L\'activité est une étape clé',
    ActivityNonBillableHours: 'Heures non facturables de l\'activité',
    ActivityProcessCondition_Text: 'Avancement de l\'activité',
    ActivityProfit: 'Profit de l\'activité',
    ActivityProfitPercentage: 'Profit de l\'activité, %',
    ActivityProgress_Text: 'Progression de l\'activité',
    ActivityStartDateCondition_Text: 'Date de début de l\'activité',
    ActivityStatusCondition_Text: 'Statut de l\'activité',
    ActivityTotalBudget: 'Budget total de l\'activité',
    ActivityTypeCondition_Text: 'Type d\'activité :',
    ActivityTypes_Issue: 'Problème',
    ActivityTypes_Request: 'Demande',
    ActivityTypes_Task: 'Tâche',
    ActivityTypesCondition_Text: 'Types d\'activité',
    ActualCompletionDate_Text: 'Date d\'achèvement réelle',
    add_filters: 'Ajouter des filtres',
    AdvancedFilterTooltipContent_Text: 'Cliquez ici pour voir toutes les options de filtrage possibles',
    AdvancedFilterTooltipTitle_Text: 'Filtres avancés',
    AllActivities_Text: 'Activité',
    Apply_Text: 'Appliquer',
    AssigneeCondition_Text: 'Assignés à l\'activité',
    AssigneeOption_Text: 'Assignés à l\'activité',
    AssigneeTeamCondition_Entity: 'équipes',
    AssigneeUserCondition_Empty_Text: 'Aucun assigné',
    AssigneeUserCondition_Entity: 'assignés à l\'activité',
    BoolCustomField_No_Text: 'Non',
    BoolCustomField_NotSelected_Text: 'Non sélectionné',
    BoolCustomField_Yes_Text: 'Oui',
    BudgetAndCosts_Filters_Group: 'Budget et coûts',
    CategoriesCondition_Text: 'Catégories',
    CategoryCondition_Empty_Text: 'Aucune catégorie',
    CategoryCondition_Entity: 'catégories',
    CategoryCondition_Text: 'Catégorie',
    Clear_All_Text: 'Effacer tous les filtres',
    CompletedStatus_Text: 'Terminé',
    constraints_filters_group: 'Contraintes',
    ContainMore_Text: 'Il y a plus de résultats, continuez à taper...',
    CreationDate_Text: 'Date de création',
    CustomerCondition_Empty_Text: 'Aucun client',
    CustomerCondition_Entity: 'clients',
    CustomerCondition_Text: 'Clients',
    CustomFieldsFilters_Group: 'Champs personnalisés',
    DraftCondition_Text: 'Brouillons',
    DraftStatus_Text: 'Brouillons',
    EndDate_Text: 'Date de fin',
    FilterByKeyword_Text: 'Filtrer par mot-clé',
    FilterByPeriod_Text: 'Filtrer par période',
    FilterByTimeframe_Text: 'Filtrer par plage de dates',
    FilterTabs_Tab1: 'Statuts',
    FilterTabs_Tab2: 'Ressources & contraintes',
    FilterTabs_Tab3: 'Santé & progression',
    FilterTabs_Tab4: 'Projets, clients & plus',
    FilterTabs_Tab5: 'Champs personnalisés',
    Followed: 'Suivi',
    FollowedByMe_Text: 'Activités suivies par moi',
    From_Text: 'de',
    general: 'Général',
    HealthCondition_Text: 'Santé',
    HealthItemType_Bad: 'Problème',
    HealthItemType_Good: 'Bon',
    HealthItemType_Medium: 'À risque',
    HealthItemType_NotCalculated: 'Non calculé',
    HealthTooltip_Text: 'La santé est un indice calculé qui montre le bon déroulement d\'un projet ou d\'une activité',
    HealthTooltipLink_Text: 'Voir plus dans notre aide en ligne',
    HoursCondition_Text: 'Temps',
    HoursFilters_Group: 'Temps',
    HoursLeft: 'Heures restantes',
    InProgressStatus_Text: 'En cours',
    InThePast: 'Dans le passé',
    InvalidDate: 'La date doit être au format \'{0}\'.',
    Issue_Text: 'Problème',
    KeepTyping_Text: 'Continuez à taper...',
    ListCustomFieldCondition_Empty_Text: 'Non sélectionné',
    ManualRange: 'Plage de dates spécifiée...',
    Me: 'Moi',
    Menu_Dates: 'Dates',
    Milestone_Text: 'Jalon',
    MoneyCondition_Text: 'Argent',
    More_Text: 'Plus',
    MultiSelectCustomFieldCondition_Empty_Text: 'Non sélectionné',
    NextMonth: 'Mois prochain',
    NextWeek: 'Semaine prochaine',
    no_filters: 'Aucun filtre à afficher',
    NoCategory: 'Aucune catégorie',
    NoMatch_Text: 'Désolé, aucun résultat trouvé',
    OnHoldStatus_Text: 'En attente',
    PeopleCondition_Text: 'Personnes',
    PinTooltip_Text: 'Épingler',
    Portfolio_Status_Text: 'Statut du portefeuille',
    PortfolioCondition_Empty_Text: 'Aucun portefeuille',
    PortfolioCondition_Entity: 'portefeuilles',
    PortfolioCondition_Text: 'Portefeuilles',
    PortfolioCreator_Text: 'Créateurs de portefeuilles',
    PortfolioCreatorCondition_Text: 'Créateur du portefeuille',
    PortfolioManager_Text: 'Gestionnaires de portefeuilles',
    PortfolioManagerCondition_Text: 'Gestionnaire du portefeuille',
    PreviousMonth: 'Mois précédent',
    PreviousWeek: 'Semaine précédente',
    PreviousYear: 'Année précédente',
    PriorityCondition_Text: 'Priorités',
    Progress_Filters_Group: 'Avancement',
    ProgressCondition_Entity: 'Avancement: ',
    ProgressCondition_Text: 'Avancement',
    Project_Text: 'Projet',
    ProjectActualBilling: 'Facturable réel du projet',
    ProjectActualCompletionDateCondition_Text: 'Date d\'achèvement réelle du projet',
    ProjectActualCost: 'Coût réel du projet',
    ProjectActualGreaterThanEstimated_Text: 'Projets sous-estimés',
    ProjectActualHours: 'Heures réelles du projet',
    ProjectActualLaborBilling: 'Main-d\'œuvre facturable réelle du projet',
    ProjectActualLaborCost: 'Coût réel de main-d\'œuvre du projet',
    ProjectBillableHours: 'Heures facturables du projet',
    ProjectBilled: 'Projet facturé',
    ProjectBilledLabor: 'Main-d\'œuvre facturée du projet',
    ProjectBilledPercentage: 'Projet facturé, %',
    ProjectBudgetVariance: 'Écart budgétaire du projet',
    ProjectCondition_EmptyText: 'Aucun projet sélectionné',
    ProjectCondition_Entity: 'projets',
    ProjectCondition_Text: 'Projets',
    ProjectCostExceedBudget_Text: 'Projets surbudgétés',
    ProjectCreationDateCondition_Text: 'Date de création du projet',
    ProjectCreator_Text: 'Créateurs de projets',
    ProjectCreatorCondition_Text: 'Créateur du projet',
    ProjectCustomFieldCondition_Text: 'Champs personnalisés du projet',
    ProjectDuration: 'Durée du projet',
    ProjectEACBillableExpenses: 'Dépenses EAC facturables du projet',
    ProjectEACBilling: 'Facturable EAC du projet',
    ProjectEACCost: 'Coût EAC du projet',
    ProjectEACExpenses: 'Dépenses EAC du projet',
    ProjectEACLaborBilling: 'Main-d\'œuvre facturable EAC du projet',
    ProjectEACLaborCost: 'Coût EAC de main-d\'œuvre du projet',
    ProjectEACNonBillableExpenses: 'Dépenses EAC non facturables du projet',
    ProjectEndDateCondition_Text: 'Date de fin du projet',
    ProjectEstimatedExpensesAmount: 'Dépenses ETC du projet',
    ProjectEstimatedExpensesBillableAmount: 'Dépenses ETC facturables du projet',
    ProjectEstimatedExpensesNonBillableAmount: 'Dépenses ETC non facturables du projet',
    ProjectEstimatedHours: 'Heures estimées du projet',
    ProjectETCBilling: 'Facturable ETC du projet',
    ProjectETCCost: 'Coût ETC du projet',
    ProjectETCLaborBilling: 'Main-d\'œuvre facturable ETC du projet',
    ProjectETCLaborCost: 'Coût ETC de main-d\'œuvre du projet',
    ProjectExpectedProfit: 'Profit attendu du projet',
    ProjectExpectedProfitPercentage: 'Profit attendu du projet, %',
    ProjectExpensesAmount: 'Dépenses réelles du projet',
    ProjectExpensesBillableAmount: 'Dépenses réelles facturables du projet',
    ProjectExpensesBilledAmount: 'Dépenses facturées du projet',
    ProjectExpensesNonBillableAmount: 'Dépenses réelles non facturables du projet',
    ProjectHealthCondition_Text: 'Santé du projet',
    ProjectHealthTypes: 'Santé du projet',
    ProjectManager_Text: 'Chefs de projets',
    ProjectManagerCondition_Text: 'Chef de projet',
    ProjectMemberCondition_Text: 'Membre du projet',
    ProjectNonBillableHours: 'Heures non facturables du projet',
    ProjectPriorityCondition_Text: 'Priorité du projet',
    ProjectPriorityCondition_Text_Template: 'Projets avec priorité %s',
    ProjectProcessCondition_Text: 'Avancement du projet',
    ProjectProfit: 'Profit du projet',
    ProjectProfit_Text: 'Projets en perte financière',
    ProjectProfitPercentage: 'Profit du projet, %',
    ProjectProgress_Text: 'Avancement du projet',
    ProjectsAndTasksList_Title: 'Projets et tâches',
    ProjectsCustomersAndMore_Filters_Group: 'Projets, clients & plus',
    ProjectStartDateCondition_Text: 'Date de début du projet',
    ProjectStatusCondition_Text: 'Statut du projet',
    ProjectTotalBudget: 'Budget total du projet',
    QuickFilterWatermark: 'Filtrer par...',
    range_condition_text: 'Plage',
    Request_Text: 'Demande',
    resource_types_condition_text: 'Ressources',
    resource_types_planning_condition_text: 'Projets avec ressources',
    resource_types_unnamed_label: 'Ressources sans nom',
    resource_types_user_label: 'Utilisateurs',
    ResourceRequestApprover_Text: 'Approbateur de la demande de ressource',
    ResourceRequestCreator_Text: 'Créateur de la demande de ressource',
    ResourceRequestStatuses_Approved: 'Approuvée',
    ResourceRequestStatuses_Rejected: 'Rejetée',
    ResourceRequestStatuses_WaitingForApproval: 'En attente d\'approbation',
    ResourceRequestStatuses_WithoutRequest: 'Sans demande',
    ResourceRequestStatusFilter_Text: 'Statut de la demande de ressource',
    resources_filters_group: 'Ressources',
    resources_requests_filters_group: 'Demandes de ressources',
    ResourcesAndConstraints_Filters_Group: 'Ressources & contraintes',
    roles_condition_text: 'Rôles',
    RollBack_Text: 'Retour aux filtres précédents',
    SaveFilters_Title: 'Filtres enregistrés',
    set_filters: 'Définir les filtres à l\'aide de',
    set_filters_part2: 'icône',
    skills_condition_text: 'Compétences',
    StartDate_Text: 'Date de début',
    Statuses_Filters_Group: 'Statut',
    StatusesCountFormat: '1#{0} statut#{0} statuts',
    Task_Text: 'Tâche',
    TaskCondition_Entity: 'activités',
    TaskCondition_Text: 'Activité',
    TaskCostExceedBudget_Text: 'Activités dépassant le budget',
    TaskPriorityCondition_Entity: 'priorités d\'activité',
    TaskPriorityCondition_Text: 'Priorité de l\'activité',
    TaskPriorityCondition_Text_Template: 'Activités avec la priorité %s',
    TasksAssignedToMilestone_Text: 'Activité assignée à une étape clé',
    teams_condition_text: 'Équipes',
    TemplateCondition_Text: 'Modèles',
    TemplateStatus_Text: 'Modèles',
    ThisMonth: 'Ce mois-ci',
    ThisWeek: 'Cette semaine',
    ThisYear: 'Cette année',
    To_Text: 'à',
    Today: 'Aujourd\'hui',
    TypesCondition_Text: 'Types',
    UnpinTooltip_Text: 'Désépingler',
    users_condition_text: 'Utilisateurs',
    Yesterday: 'Hier',
};
